import { NoticeView } from '@/shared/content/teacher-content.types';

export const TEACHER_NOTICES: readonly NoticeView[] = [
  {
    id: 'formacao',
    title: 'Formação Dia Lab',
    date: '12 JAN 2026',
    body:
      'Este é o espaço pensado para apoiar você na compreensão da proposta pedagógica do DiaLab e no uso dos recursos ao longo do ano.\n\n' +
      'Na **Formação Geral Básica**, você conhece os fundamentos do projeto, os currículos do 6º à 2ª série do EM e os materiais que orientam seu percurso formativo.\n\n' +
      'Já na **Formação por Currículo**, você acessa vídeos explicativos das trilhas e tutoriais das ferramentas de IA que fazem parte das experiências de aprendizagem.',
    cta: { kind: 'button', label: 'Acesse a formação de professores', action: 'kanttum-formation' },
  },
  {
    id: 'encontros',
    title: 'Encontros de professores / pré-projetos',
    date: '12 JAN 2026',
    body:
      'Em breve, você encontrará aqui as informações sobre datas e horários dos encontros online pré-projetos.\n\n' +
      'Esses momentos foram pensados para que possamos refletir juntos, compartilhar experiências e construir estratégias para finalizar a Trilha 01 de cada currículo de forma potente, significativa e engajadora.',
    cta: { kind: 'note', label: 'Aguarde!' },
  },
];
